module.exports = __webpack_public_path__ + "media/images/Display Screen captue-9cb241e7ad6df44b922f1bb76857f7c4.svg";